import GenericService from 'od-modules/secure_store/services/GenericService';
import updatePriceSelected from 'od-modules/helpers/membership/update_price_selected';
import updateMembershipSubscription from 'od-modules/helpers/membership/update_membership_subscription';
import refreshMembershipSubscription from 'od-modules/helpers/membership/refresh_membership_subscription';
import getMembershipSubscriptionDetails from 'od-modules/helpers/membership/membership_subscription_details';
import getMembershipInfo from 'od-modules/helpers/membership/membership_info';
import activateMembershipAutoRenewal from 'od-modules/helpers/membership/activate_membership_auto_renewal';

class MembershipService extends GenericService {
    updateMembershipSubscription(primeMemberSelected, dispatch) {
        this.service = updateMembershipSubscription;
        const requestData = this.service.formatData(primeMemberSelected);
        return this.performRequest(requestData, dispatch);
    }

    refreshMembershipSubscription(dispatch) {
        this.service = refreshMembershipSubscription;
        const requestData = {};
        return this.performRequest(requestData, dispatch);
    }

    updatePriceSelectedInSession(typeOfPrice) {
        updatePriceSelected.setTypeOfPrice(typeOfPrice);
        this.service = updatePriceSelected;
        return this.performRequest();
    }

    getMembershipSubscriptionDetails(dispatch) {
        this.service = getMembershipSubscriptionDetails;
        return this.performRequest(null, dispatch);
    }

    getMembershipInfo(dispatch) {
        this.service = getMembershipInfo;
        return this.performRequest(null, dispatch);
    }

    activateMembershipAutoRenewal(dispatch) {
        this.service = activateMembershipAutoRenewal;
        return this.performRequest(null, dispatch);
    }
}

export default new MembershipService();
